import {
  getAdvertOccupations,
  getAdvertStats,
  getAdvertStatsActivations,
  getAdWatchStats,
  getAdWatchStatsActivations,
  getAggregatedAdWatches,
  getEmployerSearchOccupations,
  getOccupationDetails,
  getOfferStats,
  getWorkLocations
} from '../../../services/stat'

export default {
  getAdvertStats ({ state, commit, getters }, { type, mode, countyId, cityId, district, from, to }) {
    return new Promise((resolve, reject) => {
      const advertisers = getters.getStatItemsBy({ type, countyId, cityId, district })
      if (advertisers.length > 0) {
        return resolve(advertisers.data)
      }

      let method = getAdvertStats
      if (mode === 'activations') method = getAdvertStatsActivations

      method({ countyId, cityId, district, from, to })
        .then(response => {
          const adverts = response.data
          commit('setAdvertStats', { countyId, cityId, district, adverts })

          resolve(adverts)
        })
        .catch(reject)
    })
  },

  getAdWatchStats ({ commit, getters }, { type, mode, countyId, cityId, district, from, to }) {
    return new Promise((resolve, reject) => {
      const adWatches = getters.getStatItemsBy({ type, countyId, cityId, district })
      if (adWatches.length > 0) {
        return resolve(adWatches.data)
      }

      let method = getAdWatchStats
      if (mode === 'activations') method = getAdWatchStatsActivations

      method({ countyId, cityId, district, from, to })
        .then(response => {
          const adWatches = response.data
          commit('setAdWatchStats', { countyId, cityId, district, adWatches })

          resolve(adWatches)
        })
        .catch(reject)
    })
  },

  getOfferStats ({ commit, getters }, { type, countyId, cityId, district, from, to }) {
    return new Promise((resolve, reject) => {
      const offers = getters.getStatItemsBy({ type, countyId, cityId, district, from, to })
      if (offers.length > 0) {
        return resolve(offers.data)
      }

      getOfferStats({ countyId, cityId, district, from, to })
        .then(response => {
          const offers = response.data
          commit('setOfferStats', { countyId, cityId, district, offers })

          resolve(offers)
        })
        .catch(reject)
    })
  },

  resetStats ({ commit }) {
    commit('resetAdvertStats')
    commit('resetAdWatchStats')
    commit('resetOfferStats')
  },

  getOccupationDetails ({ commit }, { occupationName, countyId, cityId, district }) {
    return new Promise((resolve, reject) => {
      getOccupationDetails(occupationName, { countyId, cityId, district })
        .then(response => {
          const details = response.data

          resolve(details)
        })
        .catch(reject)
    })
  },

  getAdvertOccupations ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getAdvertOccupations(params)
        .then(response => {
          const occupations = response.data
          const count = response.headers['x-total-count'] ? +response.headers['x-total-count'] : 0

          commit('setAdvertTotalCount', { count })
          commit('setAdvertOccupations', { occupations })
          resolve(occupations)
        })
        .catch(reject)
    })
  },

  getAggregatedAdWatches ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getAggregatedAdWatches(params)
        .then(response => {
          const adWatches = response.data
          commit('setAggregatedAdWatches', { adWatches })
          resolve(adWatches)
        })
        .catch(reject)
    })
  },

  getEmployerSearchOccupations ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getEmployerSearchOccupations(params)
        .then(response => {
          const occupations = response.data
          commit('setEmployerSearchOccupations', { occupations })
          resolve(occupations)
        })
        .catch(reject)
    })
  },

  getWorkLocationStatistics ({ commit }) {
    return new Promise((resolve, reject) => {
      getWorkLocations()
        .then(response => {
          const workLocations = response.data
          commit('setWorkLocationStatistics', { workLocations })
          resolve(workLocations)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stat/actions.js